module.exports = __webpack_public_path__ + "static/img/egg_b_10.1b33c01.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/eggs/b/egg_b_10.png
// module id = dRJ7
// module chunks = 1